import React from 'react';

type Props = {
  children: React.ReactComponentElement<never> | React.ReactElement;
};
const AuthLayout = ({ children }: Props) => {
  return (
    <div className="w-full h-screen p-5 md:px-10 grid lg:grid-cols-2 gap-5">
      <div className="h-full flex justify-center items-center w-full">
        <div className="w-full lg:w-[80%] border border-outline rounded-3xl p-5 flex flex-col justify-center items-center gap-5">
          <div>{children}</div>
        </div>
      </div>
      <div className="h-full bg-auth_bg bg-no-repeat bg-cover bg-center rounded-3xl hidden lg:block" />
    </div>
  );
};

export default AuthLayout;
